import {
  IOperatorInstructionModel,
  OperatorInstructModel,
} from "../OperatorInstruction/IOperatorInstructionModel";

export enum SortCartValidationResult {
  undefined = -1,
  OK = 1,
  FaultyCartNumber = 2,
  WrongCompany = 3,
  NoSortAssigned = 4,
  UnauthorizedCompany = 6,
  ShowMessage = 7,
  HasInstruction = 8,
}
export interface ISortCartResultModel {
  cartType: number;
  validationResult: SortCartValidationResult;
  sortID: number;
  sortType: number;
  workstationID: number;
  companyID: number;
  isRXSingel: boolean;
  rxEnabled: boolean;
  lastInstruction: IOperatorInstructionModel;
  instruction: IOperatorInstructionModel;
  companyName: string;
  sortCreated: string;
  isScanIdValidationRxRequired: boolean;
  isScanIdValidationRemoveSkuRequired: boolean;
  isScanIdValidationCancelSortboxRequired: boolean;
  workstationType: number;
  locationHistory: ICartLocationHistory[];
  hasHelpPicklist: boolean;
}

export interface ICartLocationHistory {
  parkLocation: number;
  parkPosition: string;
  historyDate: string;
}

export class SortCartResultModel implements ISortCartResultModel {
  cartType = Number.MIN_VALUE;
  validationResult = SortCartValidationResult.undefined;
  sortID = Number.MIN_VALUE;
  sortType = Number.MIN_VALUE;
  workstationID = Number.MIN_VALUE;
  companyID = Number.MIN_VALUE;
  isRXSingel = false;
  rxEnabled = false;
  isMultiCart = false;
  isSingleCart = false;
  lastInstruction = new OperatorInstructModel();
  instruction = new OperatorInstructModel();
  companyName = "";
  sortCreated = "1950-01-01";
  isScanIdValidationRxRequired = false;
  isScanIdValidationRemoveSkuRequired = false;
  isScanIdValidationCancelSortboxRequired = false;
  workstationType = Number.MIN_VALUE;
  locationHistory = [];
  hasHelpPicklist = false;
}
